import React from "react";
import { useState, useContext } from "react";
import { useEffect } from "react";
import { firestore } from "./config";
import { useSession } from "./UserProvider";
import { collection, doc, onSnapshot } from "firebase/firestore";

export const UserPrivilageContext = React.createContext();

export const UserPrivilageProvider = (props) => {
  const [privilages, setPrivilages] = useState({
    canAccessDMS: false,
    canAccessReports: false,
    canAcceptDonation: false,
    canUpdateDonor: false,
    canCreateDonor: false,
    isAdmin: false,
    language: "English",
    loading: true,
    taskRole: "",
    // Disabled modules - commented out
    // canAccessFMS: false,
    // canCreateDMS: false,
    // canReadDMS: false,
    // canUpdateDMS: false,
    // isStaff: false,
    // isManagement: false,
    // isAdmissionAdmin: false,
    // isParent: false,
    // isExpenseStaff: false,
    // isExpenseAuditor: false,
    // isExpenseApproverL1: false,
    // isExpenseApproverL2: false,
    // isAcademicCalendarAdmin: false,
    // canAccessGClassroomDashboard: false,
    // isGClassroomDashboardAdmin: false,
    // canAccessStudentMaster: false,
    // canUpdateStudentMaster: false,
    // canCreateStudentRecord: false,
  });
  const user = useSession();

  useEffect(() => {
    if (user.loading) {
      return;
    }
    if (!user.user) {
      setPrivilages((prev) => ({ ...prev, loading: false, taskRole: "" }));
      return;
    }

    const usersCollection = collection(firestore, "users");
    let userInfo = user.user;
    const userDocRef = doc(usersCollection, userInfo.uid);
    // Listen for changes to the document
    const unsubscribe = onSnapshot(userDocRef, (doc) => {
      const userData = doc.data();

      if (userData !== undefined) {
        setPrivilages({
          canAccessDMS:
            userData.dms !== undefined ? userData.dms.canAccess : false,
          canAccessReports:
            userData.dms !== undefined
              ? userData.dms.canAccessReports
              : false,
          canAcceptDonation:
            userData.dms !== undefined
              ? userData.dms.canAcceptDonation
              : false,
          canUpdateDonor:
            userData.dms !== undefined ? userData.dms.canUpdateDonor : false,
          canCreateDonor:
            userData.dms !== undefined ? userData.dms.canCreateDonor : false,
          isAdmin: userData.isAdmin !== undefined ? userData.isAdmin : false,
          language: userData.language !== undefined ? userData.language : "",
          taskRole: userData.taskRole !== undefined ? userData.taskRole : "TaskUser",
          loading: false,
        });
      } else {
        setPrivilages((prev) => ({ ...prev, loading: false, taskRole: "TaskUser" }));
      }
    });

    return () => unsubscribe();
  }, [user]);

  return (
    <UserPrivilageContext.Provider value={privilages}>
      {!privilages.loading && props.children}
    </UserPrivilageContext.Provider>
  );
};

export const resetUserPrivilages = () => {};
export const GetUserPrivilages = () => {
  return useContext(UserPrivilageContext);
};
